import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MatCardModule } from "@angular/material/card";

@Component({
	selector: "cp-base-card",
	imports: [CommonModule, MatCardModule],
	templateUrl: "./base-card.component.html",
	styleUrl: "./base-card.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpBaseCardComponent {
	@Input() customClass?: string;
	@Input() withoutBottomPadding = false;
}
